
const Config = {
  backendUrl: "https://dev.backendsportunity2017.com/graphql",
  authUrl: "https://dev.backendsportunity2017.com/auth/admin",
  lang : 'EN',
  webapp: "http://dev.sportunity.com/",
}

export default Config;



// WEBPACK FOOTER //
// ./src/Config.js